import React from "react";
import UnitCardV3 from "../UnitCardV3";
import { UnitListItemV3Props } from "../types";

const UnitListItemV3: React.FC<UnitListItemV3Props> = ({
  item,
  onPressUnit,
  onPressCollection,
  shouldLoadMedia,
  styles,
}) => {
  const handlePress = React.useCallback(() => {
    onPressUnit(item.unit.id);
  }, [item.unit.id, onPressUnit]);

  return (
    <UnitCardV3
      item={item}
      onPress={handlePress}
      onPressCollection={onPressCollection}
      shouldLoadMedia={shouldLoadMedia}
      styles={styles}
    />
  );
};

export default React.memo(UnitListItemV3);

